<template>

  <modalo
    :creating="creating"
    :title="null"
    type="long"
    :padding="'0px'"
    @hideModal="hideModal()"
    :showNext="Boolean(nextCandidateId)"
    :showPrevious="Boolean(previousCandidateId)"
    @next="next"
    @previous="previous">

    <div class="hflex">
      <div class="hflex-col-1">
        <candidate-info>
          </candidate-info>
      </div>
      <div class="hflex-col-1 p-3 col-activities">
        <candidateActivities />
      </div>
    </div>

    <template
      slot="footer"
      v-if="duplicates && duplicates.length >= 2">

      <candidate-duplicates
        @selectCandidate="loadCandidate">
        </candidate-duplicates>

    </template>

  </modalo>

</template>

<script>
import CandidateInfo from './CandidateInfo'
import CandidateActivities from './CandidateActivities.vue'
import CandidateDuplicates from './Duplicates/CandidateDuplicates'

export default {
  name: 'Candidate',
  components: {
    CandidateInfo,
    CandidateActivities,
    CandidateDuplicates
  },
  props: [
  ],
  data () {
    return {
      creating: true
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidateId () {
      return this.$route.query.candidate_id
    },
    candidateJobId () {
      return this.$route.query.candidate_job_id
    },
    candidateJobStageId () {
      return this.$route.query.candidate_job_stage_id
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    duplicates () {
      return this.$store.getters.getDuplicates
    },
    candidatesBoard () {
      return this.$store.getters.getCandidateBoards.filter(candidate => {
        return candidate.placement && candidate.placement.stage_id && candidate.placement.stage_id._id === this.candidateJobStageId
      })
    },
    candidateBoardIndex () {
      if (!this.candidateJobStageId) {
        return -1
      }
      return this.candidatesBoard.findIndex(item => {
        return item._id === this.candidateId
      })
    },
    previousCandidateId () {
      const index = this.candidateBoardIndex
      if (index >= 1 && index <= this.candidatesBoard.length) {
        return this.candidatesBoard[index - 1]._id
      }
      return null
    },
    nextCandidateId () {
      const index = this.candidateBoardIndex
      if (index >= 0 && index <= this.candidatesBoard.length - 2) {
        return this.candidatesBoard[index + 1]._id
      }
      return null
    }
  },
  metaInfo () {
    return {
      title: this.creating ? 'Carregando...' : this.candidate.name
    }
  },
  created () {
    this.loadCandidate(this.candidateId)
  },
  methods: {
    /*
    loadCandidate
    */
    loadCandidate (candidateId) {
      Promise.all([
        this.$store.dispatch('selectCandidate', candidateId),
        this.$store.dispatch('selectDuplicates', { candidate_id: candidateId }),
        this.$store.dispatch('selectStages', { limit: 1000 }),
        this.$store.dispatch('selectDisqualifyReasons', { sort: 'name', limit: 1000 })
      ])
      .then(() => {
        if (this.candidateJobId && this.permissions.includes('manage_candidates')) {
          const placement = this.candidate.placements.find(v => v.job_id === this.candidateJobId)

          if (placement && placement.new) {
            this.$store
            .dispatch('updatePlacement', {
              _id: placement._id,
              new: false
            })
          }
        }

        this.creating = false
      })
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    previous () {
      this.$openCandidateModal(this.previousCandidateId, {
        candidate_job_id: this.candidateJobId,
        candidate_job_stage_id: this.candidateJobStageId
      })
    },
    next () {
      this.$openCandidateModal(this.nextCandidateId, {
        candidate_job_id: this.candidateJobId,
        candidate_job_stage_id: this.candidateJobStageId
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-activities {
  position: relative;
  background: rgba(0, 0, 0, 0.1)
}
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Candidate.vue